(function ($) {
    $(function () {

        $('.panel-group').each(function (accordionIndex) {

            var accordionName = 'accordion' + accordionIndex;

            $(this).attr('id', accordionName);

            $(this).find('a[data-toggle="collapse"]').each(function (index) {
                $(this).attr('href', '#' + accordionName + '-collapse-' + index);
                $(this).attr('data-parent', '#' + accordionName);

            });

            $(this).find('.panel-collapse').each(function (index) {
                $(this).attr('id', accordionName + '-collapse-' + index);
            });

        });
    });
})(window.jQuery);